module.exports = __webpack_public_path__ + "static/media/picnic-table.e1d5c473.svg";